import { render, staticRenderFns } from "./shippingFee.vue?vue&type=template&id=6b546bca&scoped=true&"
import script from "./shippingFee.vue?vue&type=script&lang=js&"
export * from "./shippingFee.vue?vue&type=script&lang=js&"
import style0 from "./shippingFee.vue?vue&type=style&index=0&id=6b546bca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b546bca",
  null
  
)

export default component.exports